import { render } from "./PrestacaoDeContas.vue?vue&type=template&id=2d004db9&scoped=true"
import script from "./PrestacaoDeContas.vue?vue&type=script&lang=js"
export * from "./PrestacaoDeContas.vue?vue&type=script&lang=js"

import "./PrestacaoDeContas.vue?vue&type=style&index=0&id=2d004db9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d004db9"]])

export default __exports__